module.exports = __webpack_public_path__ + "img/96e800b023926189c7333efc1b097c1c.png";